import { render, staticRenderFns } from "./NumberContent.vue?vue&type=template&id=5208c54e&scoped=true&"
import script from "./NumberContent.vue?vue&type=script&lang=js&"
export * from "./NumberContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5208c54e",
  null
  
)

export default component.exports